import React, { useEffect } from 'react';

import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice';
import { useDispatch, useSelector } from 'react-redux';

const Navbar = React.lazy(() => import('./components/Navbar'));
const Yacht = React.lazy(() => import('./components/Yacht'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import { scrollToTop } from '../../utils/funtions.js';


const YachtPage = () => {
  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);

  useEffect(() => {
    scrollToTop();
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht())
    }
  }, [])
  return (
    <div className='bg-white'>
      <Navbar yachtState={yachtState.yachts} />
      <Yacht />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default YachtPage;